import { useQuery } from "@tanstack/react-query";
import type { AuctionItem, AuctionCategory } from "@/types/auction";

const API_BASE = "https://api.opsucht.net/auctions";

export const useAuctionCategories = () => {
  return useQuery<AuctionCategory[]>({
    queryKey: ["auction-categories"],
    queryFn: async () => {
      try {
        const response = await fetch(`${API_BASE}/categories`);
        if (!response.ok) throw new Error();
        return response.json();
      } catch {
        throw new Error("Unable to load auction categories. Please try again later.");
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export const useActiveAuctions = (category?: string) => {
  return useQuery<AuctionItem[]>({
    queryKey: ["active-auctions", category],
    queryFn: async () => {
      try {
        const url = new URL(`${API_BASE}/active`);
        if (category) {
          url.searchParams.set('category', category);
        }
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error();
        return response.json();
      } catch {
        throw new Error("Unable to load auctions. Please try again later.");
      }
    },
    staleTime: 1000 * 30, // 30 seconds
    refetchInterval: 1000 * 60, // refetch every minute
  });
};
